import { DocumentNode, gql } from '@apollo/client';
import { Stack } from '@chakra-ui/react';
import * as React from 'react';

import { SeeMoreButtons_PostV2Fragment } from './graphql-types/SeeMoreButtons_PostV2Fragment';

import { SeeMorePosts } from './components/SeeMorePosts';
import { SeeSimilarPosts } from './components/SeeSimilarPosts';

export const SeeMoreButtons: React.FC<{
  post: SeeMoreButtons_PostV2Fragment;
}> & {
  postFragment: DocumentNode;
} = ({ post }) => {
  const hasTags = !!post.tags?.length;
  const firstTagId = (post.tags && post.tags[0]?._id) ?? '';

  return (
    <Stack direction="row" justify="center" spacing="6">
      <SeeMorePosts variant={hasTags ? 'outline' : 'solid'} />

      {hasTags && <SeeSimilarPosts tagId={firstTagId} />}
    </Stack>
  );
};

SeeMoreButtons.postFragment = gql`
  fragment SeeMoreButtons_PostV2Fragment on PostV2 {
    _id
    tags {
      _id
    }
  }
`;
